import React from "react";
import { useNavigate } from "react-router-dom";
import Modal from "./Modal";

const InviteSuccessModal = ({ event, prize, onClose, show }) => {
  const navigate = useNavigate();

  const handleClaimPrize = () => {
    if (!prize?.redirect_url) return;

    // Go to the thankspage with the code
    navigate(`/profile/prizes`);
    onClose();
  };

  return (
    <Modal show={show} onClose={onClose} title="Claim jouw prijs" width="500px">
      <p className="mb-4 text-white">
        Een vriend(in) heeft een gratis ticket gewonnen en neemt jou mee als +1.
        Klik hier om jouw ticket te claimen.
      </p>

      <button
        onClick={handleClaimPrize}
        className="p-[10px] !pb-[10px] !border-[2px] border-[#9865db] rounded-[4px] w-full font-semibold text-[16px] text-white premium-button"
      >
        Claim prijs
      </button>
    </Modal>
  );
};

export default InviteSuccessModal;
